import { useCallback, useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";

function buildPayload(form) {
  const payload = {
    expense_date: form.expense_date,
    category: form.category,
    amount: parseFloat(form.amount) || 0,
    vendor: form.vendor || null,
    notes: form.notes || null,
    deal_id: form.deal_id || null,
  };
  if (form.category === "Mileage" && form.miles) {
    payload.miles = parseFloat(form.miles);
  }
  return payload;
}

export function useExpenses() {
  const [items, setItems] = useState([]);
  const [categories, setCategories] = useState([]);
  const [deals, setDeals] = useState([]);

  const load = useCallback(async () => {
    const [r1, r2, r3] = await Promise.all([
      api.get("/expenses"),
      api.get("/expenses/categories"),
      api.get("/deals"),
    ]);
    setItems(r1.data);
    setCategories(r2.data);
    setDeals(r3.data);
  }, []);

  useEffect(() => { load(); }, [load]);

  const create = useCallback(async (form) => {
    try {
      await api.post("/expenses", buildPayload(form));
      toast.success("Expense logged");
      await load();
      return true;
    } catch (err) {
      toast.error(formatApiError(err));
      return false;
    }
  }, [load]);

  const update = useCallback(async (id, draft) => {
    try {
      await api.put(`/expenses/${id}`, buildPayload(draft));
      toast.success("Updated");
      await load();
      return true;
    } catch (err) {
      toast.error(formatApiError(err));
      return false;
    }
  }, [load]);

  const remove = useCallback(async (id) => {
    if (!window.confirm("Delete this expense?")) return;
    try {
      await api.delete(`/expenses/${id}`);
      toast.success("Expense deleted");
      await load();
    } catch (err) {
      toast.error(formatApiError(err));
    }
  }, [load]);

  return { items, categories, deals, create, update, remove };
}
